import React, { useEffect } from "react";
import "./CareerPageContent.css";

const JobsList = () => {
    useEffect(() => {
        // Clean up any existing widget script to allow clean initialization
        const existingScript = document.querySelector('script[src*="career-widget"]');
        if (existingScript) {
            existingScript.remove();
        }

        const script = document.createElement("script");
        script.src = "https://one.connectmarvel.com/career-widget.js";
        script.setAttribute("data-site", "cs_b6goak3ka7ve586vd4hdk8ps");
        script.async = true;
        document.body.appendChild(script);

        return () => {
            const s = document.querySelector('script[src*="career-widget"]');
            if (s) {
                s.remove();
            }
        };
    }, []);

    return (
        <div className="career-modern-page">
            <section className="career-opportunities-section" style={{ borderTop: "none", paddingTop: "50px" }}>
                <div className="career-container">
                    <div className="career-section-header">
                        <div className="career-header-left">
                            <span className="career-kicker">YOUR NEXT CHAPTER STARTS HERE</span>
                            <h1 className="career-main-heading">Find your opportunity.</h1>
                        </div>
                        <div className="career-header-right">
                            <p className="career-header-desc">
                                Explore current opportunities across sales, operations, design and leadership. Filter by location or search for a role that matches your experience.
                            </p>
                        </div>
                    </div>

                    {/* Realtime Openings Widget from internal CRM */}
                    <div className="career-widget-container">
                        <div id="marvel-careers"></div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default JobsList;
